import React from "react";
import WarningBanner from "../../../../components/ui/feedback/WarningBanner";

/**
 * Info/warning banner shown before sending dispatch SMS messages. Displays a
 * prompt when no recipients are selected, otherwise the outbound message count.
 *
 * @param {Object} props
 * @param {number} props.messageCount Number of SMS recipients selected.
 * @param {number} [props.costPerMessage=0.021] Cost per message in dollars (reserved for future copy).
 * @returns {JSX.Element}
 */
export default function SMSCostWarning({
  messageCount,
  costPerMessage = 0.021,
}) {
  // const cost = (messageCount * costPerMessage).toFixed(2);
  const costLine = (
    <p>
      This will send <b>{messageCount} SMS messages</b>
    </p>
  );

  if (messageCount === 0) {
    return (
      <WarningBanner variant="info">
        <p>Please select workers to send your message.</p>
      </WarningBanner>
    );
  }

  return (
    <WarningBanner variant="warning">
      {costLine}
    </WarningBanner>
  );
}
